import { useTranslation } from 'react-i18next'
import { ButtonLink } from '../components/Button'
import { EmptyState } from '../components/States'

export function NotFound() {
  const { t } = useTranslation()
  return (
    <div className="container screen">
      <title>{t('app.notFound.metaTitle')}</title>
      <h1 className="visually-hidden">{t('app.notFound.title')}</h1>
      <EmptyState
        icon="home"
        title={t('app.notFound.title')}
        body={t('app.notFound.body')}
        action={
          <ButtonLink to="/" variant="secondary" icon="home">
            {t('app.notFound.home')}
          </ButtonLink>
        }
      />
    </div>
  )
}
